
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 6v1.154a1 1 0 01-2 0V5.2A1.2 1.2 0 016.2 4h11.6A1.2 1.2 0 0119 5.2v1.954a1 1 0 11-2 0V6h-4v12h2a1 1 0 110 2H9a1 1 0 110-2h2V6H7z","fill":"#191F2D"}})])
          )
        }
      }
    